import { Belief } from '../../components/Belief';
import { useMemo } from 'react';
import { formatSentenceCase } from 'src/interviews/utils/formatTitleCasing';
import useChatList from 'src/interviews/hooks/useChatList';
import MessageBox from 'src/interviews/components/MessageBox';

import type { IInterviewResults } from 'src/packages/polaris/types';

const getAlarmMessage = (belief: Belief, isInitialWarning: boolean, conditionName?: string) => {
  if (isInitialWarning) {
    return `${formatSentenceCase(conditionName || 'This')} is a serious, potentially life-threatening condition. If you have any concerns about this being an emergency, please call 911 or go to your nearest hospital emergency room.`;
  }
  switch (belief) {
    case Belief.Likely:
      return 'Because this is a potentially life-threatening condition, consider seeking medical care immediately.';
    default:
      return 'Because this is a potentially life-threatening condition, please seek medical care if you suspect you might be experiencing a medical emergency.';
  }
};

function DXOCAlarmMessage({
  result,
  conditionName,
  isInitialWarning = false,
}: {
  result?: IInterviewResults;
  conditionName?: string;
  isInitialWarning?: boolean;
}) {
  const chatList = useChatList();
  const isAlarmingDxOC = !!chatList.items.find((item) => item.dxoc_is_alarming);

  const diagnosis = result?.diagnosis_of_concern || ({} as any);

  const alarmMessage = useMemo(
    () => getAlarmMessage(diagnosis.belief, isInitialWarning, conditionName),
    [diagnosis.belief, isInitialWarning, conditionName],
  );

  if (!isAlarmingDxOC) {
    return null;
  }

  return (
    <MessageBox
      header={isInitialWarning ? 'Alarming scenario warning' : ''}
      alarmMessage={alarmMessage}
      color={isInitialWarning || diagnosis.belief === Belief.Likely ? 'red' : 'gray'}
    />
  );
}

export default DXOCAlarmMessage;
